import { render, staticRenderFns } from "./PatientHistoryItemAll.vue?vue&type=template&id=65581148&scoped=true&lang=pug&"
import script from "./PatientHistoryItemAll.vue?vue&type=script&lang=js&"
export * from "./PatientHistoryItemAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65581148",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
